import React from 'react';

import { CheckmarkCircleFill } from '@lyearn/icons';

type VerticalDashedLineProps = {
  height: number;
  points: number[];
  strokeColor?: string;
  iconSize?: number; // Size of your checkmark icon
};

const SAFE_AREA = 5; // Safe area around the icons to prevent overflow

const VerticalDashedLine: React.FC<VerticalDashedLineProps> = ({
  height,
  points,
  strokeColor = '#BFBFBF',
  iconSize = 20,
}) => {
  const centerX = iconSize; // center of line is at `iconSize` px (half of SVG width)

  return (
    <svg
      height={height + SAFE_AREA} // Add safe area to height
      viewBox={`0 0 ${iconSize * 2} ${height + SAFE_AREA}`}
      width={iconSize * 2}
      xmlns="http://www.w3.org/2000/svg">
      {/* Vertical dashed line */}
      <line
        stroke={strokeColor}
        strokeDasharray="2,4"
        strokeWidth={2}
        x1={centerX}
        x2={centerX}
        y1={0}
        y2={height}
      />

      {/* Render icons centered on the line */}
      {points.map((point, index) =>
        point >= 0 && point <= height ? (
          <foreignObject
            key={index}
            height={iconSize}
            style={{ overflow: 'visible' }}
            width={iconSize}
            x={centerX - iconSize / 2}
            y={point + 4 - iconSize / 2}>
            <div
              style={{
                width: iconSize,
                height: iconSize,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <CheckmarkCircleFill className="w-full h-full" />
            </div>
          </foreignObject>
        ) : null,
      )}
    </svg>
  );
};

export default VerticalDashedLine;
